export class SearchedData {
    type: string;
    results: Array<any>;
}

export class SearchPayload {
    constructor(
        public scope?: string,
        public searchKey?: string,
        public filters?: SearchFilters
    ) {}
}

export class SearchFilters {
    constructor(
        public category?: string,
        public accountId?: string,
        public fromDate?: any,
        public toDate?: any
    ) {}
}

export class SearchParam {

    constructor(
        public scope?: string,
        public filters?: Array<string>,
        public placeholder?: string
    ) {}
}